import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import AddressbookPanelShell from "../../addressbook/panels/AddressbookPanelShell";

const STAGE_STYLE = {
  consultation:    { color: "#475569", bg: "#F1F5F9" },
  agreementSigned: { color: "#3949AB", bg: "#E8EAF6" },
  activeSearch:    { color: "#1E40AF", bg: "#DBEAFE" },
  loiSubmitted:    { color: "#92400E", bg: "#FEF3C7" },
  underContract:   { color: "#065F46", bg: "#D1FAE5" },
  closed:          { color: "#334155", bg: "#E2E8F0" },
  dead:            { color: "#7F1D1D", bg: "#FEE2E2" },
};

const STAGE_LABEL = {
  consultation: "Consultation",
  agreementSigned: "Agreement Signed",
  activeSearch: "Active Search",
  loiSubmitted: "LOI Submitted",
  underContract: "Under Contract",
  closed: "Closed",
  dead: "Dead",
};

const DealListPanel = ({
  onClose,
  deals = [],
  selectedId,
  searchValue = "",
  onSearchChange,
  onSelect,
  loading = false,
}) => (
  <AddressbookPanelShell
    onClose={onClose}
    titleContent={
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1A1F36" }}>
        {`Deals${deals.length ? ` (${deals.length})` : ""}`}
      </Typography>
    }
    headerActions={
      <TextField
        size="small"
        placeholder="Search deals"
        value={searchValue}
        onChange={(e) => onSearchChange?.(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 15, color: "#94A3B8" }} />
            </InputAdornment>
          ),
          sx: { fontSize: 12, height: 30 },
        }}
        sx={{ width: 170 }}
      />
    }
  >
    {loading ? (
      <Typography sx={{ px: 1.5, py: 2, fontSize: 12, color: "#94A3B8" }}>Loading…</Typography>
    ) : deals.length === 0 ? (
      <Typography sx={{ px: 1.5, py: 2, fontSize: 12, color: "#94A3B8" }}>
        No deals yet.
      </Typography>
    ) : (
      deals.map((deal) => {
        const stage = STAGE_STYLE[deal.stage] || STAGE_STYLE.consultation;
        const selected = deal.id === selectedId;
        return (
          <Box
            key={deal.id}
            onClick={() => onSelect?.(deal)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.25,
              py: 0.9,
              cursor: "pointer",
              borderBottom: "1px solid #F4F5FB",
              backgroundColor: selected ? "#E8EAF6" : "transparent",
              "&:hover": { backgroundColor: selected ? "#E8EAF6" : "#F4F5FB" },
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: 12.5,
                  fontWeight: 600,
                  color: "#1A1F36",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {deal.name}
              </Typography>
              <Typography sx={{ fontSize: 10.5, color: "#94A3B8" }}>
                {[deal.dealType, deal.side].filter(Boolean).join(" • ") || "—"}
              </Typography>
            </Box>
            {deal.stage ? (
              <Box
                sx={{
                  px: 0.75,
                  py: 0.2,
                  borderRadius: 1,
                  fontSize: 10,
                  fontWeight: 700,
                  color: stage.color,
                  backgroundColor: stage.bg,
                  whiteSpace: "nowrap",
                }}
              >
                {STAGE_LABEL[deal.stage] || deal.stage}
              </Box>
            ) : null}
          </Box>
        );
      })
    )}
  </AddressbookPanelShell>
);

export { STAGE_LABEL };
export default DealListPanel;
